export default __webpack_public_path__ + "static/media/800ef1136ac55822.0732c7e244f4374f2e5f3bded430f213.svg";